import React from "react";
import * as constants from '../constants/constants';
import NotFound from './NotFound';
import { Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import Home from '../pages/Home';
import Curso from '../pages/Curso';
import Examen from '../pages/Examen';


function RouterConfig() {

    return (
        <Routes>
            <Route exact path={constants.HOME} element={<Home />} />
            <Route exact path={constants.CURSO} element={<ProtectedRoute><Curso /></ProtectedRoute>} />
            <Route exact path={constants.EXAMEN} element={<ProtectedRoute><Examen /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default RouterConfig;
